<div class="ai-loader">
  <!-- Header: icon + current step title + counter + toggle -->
  <div class="ai-loader__header">
    <ui-svg-icon svgIcon="ai-volta-icon" size="small" class="ai-loader__icon"></ui-svg-icon>
    <span class="ai-loader__title">{{ currentStep.labelKey | translate }}...</span>
    <span class="ai-loader__counter">
      {{ 'smart_inbox.compose.ai_loader.step_counter' | translate: { current: currentStepIndex + 1, total: steps.length } }}
    </span>
    <button type="button" class="ai-loader__toggle" (click)="toggleExpanded()" [attr.aria-label]="'smart_inbox.compose.aria_close' | translate">
      <mat-icon class="ai-loader__chevron" [class.ai-loader__chevron--expanded]="expanded">expand_more</mat-icon>
    </button>
  </div>

  <!-- Progress bar -->
  <div class="ai-loader__progress-track">
    <div class="ai-loader__progress-fill" [style.width.%]="progressPercent"></div>
  </div>

  <!-- Step list -->
  <div class="ai-loader__steps" *ngIf="expanded">
    <div class="ai-loader__step" *ngFor="let step of visibleSteps">
      <mat-icon class="ai-loader__step-icon">check</mat-icon>
      <span class="ai-loader__step-label" [class.ai-loader__step-label--done]="!!step.completedAt">
        {{ step.labelKey | translate }}
      </span>
      <span class="ai-loader__step-duration" *ngIf="step.completedAt && step.startedAt">
        {{ (step.completedAt - step.startedAt) / 1000 | number:'1.1-1' }}s
      </span>
    </div>
  </div>
</div>
